import React from 'react';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Typography from '@visa/vds/typography';
import Checkbox from '@visa/vds/checkbox';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import MCSToolTip from '../../../components/MCSToolTip';
import MCSSpace from '../../../components/MCSSpace';
import { UserRole } from '../../../_constants/UserRole';
import { Radio, RadioGroup } from '@visa/vds';

const AdditionalEntitlements = (props) => {
    return (
        <>
            <MCSSpace />
            {props.user && props.user.entitleId <= UserRole.ToolsAdmin_Entitlement &&
                <Row noGutter>
                    <Col>
                        <Typography tag="h3">Additional Entitlements</Typography>
                    </Col>
                </Row>}

            {props.user && (props.user.entitleId === UserRole.StoreAdmin_Entitlement || props.user.entitleId === UserRole.ToolsAdmin_Entitlement) &&
                <Row noGutter key={5}>
                    <Col noTopGutter noGutter lg={6}>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    checked={props.user.isLibraryManager} onChange={props.toggleLibraryManager}
                                    id={"lib"} label={"Manage Library Content"}
                                    name="checkbox-lib"
                                />
                            </CheckboxListItem>
                        </CheckboxList>

                    </Col>
                    <Col noTopGutter noGutter lg={6} />
                </Row>
            }

            {props.user && props.user.entitleId === UserRole.ToolsAdmin_Entitlement &&
                <Row noGutter key={6}>

                    <Col noTopGutter noGutter lg={6}>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    checked={props.user.isSifManager} onChange={props.toggleSifManager}
                                    id={"sif"} label={"Sign Off SIF"}
                                    name="checkbox-sif"
                                />
                            </CheckboxListItem>
                            <CheckboxListItem>
                                <Checkbox
                                    checked={props.user.isVstsWorkflowAdmin} onChange={props.toggleVstsWorkflowAdmin}
                                    disabled={props.currentUser.entitleId !== UserRole.SuperAdmin_Entitlement}
                                    id={"vstsWorkflowAdmin"} label={"VSS Certification Workflow"}
                                    name="checkbox-vstsWorkflowAdmin"
                                />
                                <MCSToolTip
                                    message="Entitles the user to perform workflow admin functions for Certification Packages. The user is able to edit/review/approve Certification Packages and extend VSTS subscriptions."
                                    id="vstsWorkflowAdmin-tooltip"
                                    iconName="info"
                                />
                            </CheckboxListItem>
                            <CheckboxListItem>
                                <Checkbox
                                    checked={props.user.hasReportingExport} onChange={props.toggleHasReportingExport}
                                    disabled={props.currentUser.entitleId !== UserRole.SuperAdmin_Entitlement}
                                    id={"hasReportingExport"} label={"Reporting and Export"}
                                    name="checkbox-hasReportingExport"
                                />
                                <MCSToolTip
                                    message="Entitled to run reports and export VSS data"
                                    id="hasReportingExport-tooltip"
                                    iconName="info"
                                />
                            </CheckboxListItem>
                        </CheckboxList>
                    </Col>
                    <Col noTopGutter noGutter lg={6} />
                </Row>
            }

            {
                props.user && (props.user.entitleId === UserRole.UserInternal_Entitlement || props.user.entitleId === UserRole.ToolsAdmin_Entitlement) &&
                <Row noGutter key={6}>

                    <Col noTopGutter noGutter lg={6}>
                        <CheckboxList>
                            <CheckboxListItem>
                                {/* <Checkbox
                                    checked={props.user.isVmidParticipation} onChange={props.toggleVmidParticipation}
                                    disabled={props.currentUser.entitleId !== UserRole.SuperAdmin_Entitlement}
                                    id={"vmidParticipation"} label={"3DS DAF VMID Participation Flags & Parameters"}
                                    name="checkbox-participation"
                                /> */}

                                {/* <Checkbox
                                    checked={props.user.isVmidFileUpload} onChange={props.toggleVmidFileUpload}
                                    disabled={props.currentUser.entitleId !== UserRole.SuperAdmin_Entitlement}
                                    id={"vmidFileUpload"} label={"3DS DAF VMID File Upload"}
                                    name="checkbox-fileupload"
                                /> */}
                            </CheckboxListItem>
                        </CheckboxList>
                    </Col>
                    <Col noTopGutter noGutter lg={6} />
                </Row>
            }

            {props.user && props.user.entitleId === UserRole.UserExternal_Entitlement &&
                <Row noGutter key={7}>
                    <Col noTopGutter noGutter lg={6}>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    checked={props.user.isSubscriptionManager} onChange={props.toggleSubscriptionManager}
                                    id={"subscriptionManager"} label={"Subscription Manager"}
                                    name="checkbox-subscription"
                                />
                                <MCSToolTip
                                    message="'Subscription Manager' is a Visa Secure Service assigned user entitlement. A user ID with the subscription manager role assigned can access the 3DS Store, view items in the 3DS Store, and purchase Visa Secure subscriptions. Subscription Managers can be assigned to existing VSS users by the Store Admin and the Tools and Library Admin. By default, when creating a UVID (Enterprise ID) the first two UVID users are assigned role of 'subscription manager'"
                                    id="subscriptionManager-tooltip"
                                    iconName="info"
                                />

                                {/* <Checkbox
                                    checked={props.user.isAcquirerVmid} onChange={props.toggleAcquirerVmid}
                                    disabled={props.currentUser.entitleId !== UserRole.SuperAdmin_Entitlement}
                                    id={"acquirerVmid"} label={"3DS DAF Acquirer VMID Flag"}
                                    name="checkbox-acquirer"
                                /> */}
                                <Checkbox
                                    checked={props.user.isCompanyAdmin} onChange={props.toggleCompanyAdmin}
                                    id={"companyAdmin"} label={"Company Admin"}
                                    name="checkbox-subscription"
                                />
                            </CheckboxListItem>
                        </CheckboxList>
                    </Col>
                    <Col noTopGutter noGutter lg={6} />
                </Row>
            }

            {props.user && props.user.entitleId === UserRole.UserInternal_Entitlement &&
                (props.currentUser.entitleId >= UserRole.ToolsAdmin_Entitlement) &&
                <Row noGutter key={7}>
                    <Col noTopGutter noGutter lg={6}>
                        <Col noGutter>
                            <CheckboxList>
                                <CheckboxListItem>
                                    <Checkbox
                                        checked={props.user.hasVisaInternalExtendedAccess} onChange={props.toggleVisaInternalAccess}
                                        id={"visaExtendedAccess"} label={"Extended Access"}
                                        name="checkbox-extendedaccess"
                                    />
                                    <MCSToolTip
                                        message="Extended Access for Visa Staff provides additional access to Subscription Content, 3DS Store, Visa Internal Process documents and access to Approved Product List - Internal Version."
                                        id="extendedAccess-tooltip"
                                        iconName="info"
                                    />
                                </CheckboxListItem>
                            </CheckboxList>
                            {props.user.hasVisaInternalExtendedAccess &&
                                <CheckboxList style={{ paddingLeft: "30px" }}>
                                    <CheckboxListItem>
                                        <Checkbox
                                            checked={props.user.hasVstsL0} onChange={props.toggleVstsL0}
                                            id={"vstsL0"} label={"VSTS L0 Access"}
                                            name="checkbox-vstsL0"
                                            disabled={props.currentUser.entitleId == UserRole.ToolsAdmin_Entitlement}
                                        />
                                        <MCSToolTip
                                            message="Entitles the user access to VSTS. VSTS recognizes this Role and Entitlement and provides the user the necessary functions to view test cases and create test VSTS Test Projects. This user can view client data or request a compliance letter."
                                            id="vstsL0-tooltip"
                                            iconName="info"
                                        />
                                    </CheckboxListItem>
                                </CheckboxList>
                            }
                        </Col>
                        <Col noTopGutter noGutter lg={6} />
                    </Col>
                </Row>
            }

            {props.user && props.user.entitleId >= UserRole.ToolsAdmin_Entitlement &&
                (props.currentUser.entitleId >= UserRole.ToolsAdmin_Entitlement) &&
                <>
                    <Row>
                        <Typography style={{ marginTop: '10px' }} tag="h4"><strong>VSTS Entitlements</strong></Typography>
                    </Row>
                    <Row>
                        <Col>
                            <RadioGroup style={{ marginTop: "-15px", marginLeft: "-20px" }}>
                                <div className='display-flex align-items-center'>
                                    <Radio
                                        name="adminVstsEntitlement"
                                        value={1}
                                        label="L1 Support Admin"
                                        onChange={props.handleAdminVstsEntitlementsRadioBtnChange}
                                        checked={props.vstsEntitlements === 1}
                                        disabled={props.currentUser.entitleId == UserRole.ToolsAdmin_Entitlement}
                                    />
                                    <MCSToolTip
                                        message="Entitles the user access to VSTS. VSTS recognizes this Role and Entitlement tiers and provides the user the necessary functions. VSTS L1 Support Admin: View client test cases. VSTS L2 GCT Admin: View, review, and approve client test cases and projects. VSTS L3 Dev Admin: Create and edit test cases."
                                        id="vstsL1-tooltip"
                                        iconName="info"
                                    />
                                </div>
                                <div className='display-flex align-items-center'>

                                    <Radio
                                        name="adminVstsEntitlement"
                                        value={2}
                                        label="L2 GCT Admin"
                                        onChange={props.handleAdminVstsEntitlementsRadioBtnChange}
                                        checked={props.vstsEntitlements === 2}
                                        disabled={props.currentUser.entitleId == UserRole.ToolsAdmin_Entitlement}

                                    />
                                    <MCSToolTip
                                        message="Entitles the user access to VSTS. VSTS recognizes this Role and Entitlement tiers and provides the user the necessary functions. VSTS L1 Support Admin: View client test cases. VSTS L2 GCT Admin: View, review, and approve client test cases and projects. VSTS L3 Dev Admin: Create and edit test cases."
                                        iconName="info"
                                    />
                                </div>
                                <div className='display-flex align-items-center'>

                                    <Radio
                                        name="adminVstsEntitlement"
                                        value={3}
                                        label="L3 Dev Admin"
                                        onChange={props.handleAdminVstsEntitlementsRadioBtnChange}
                                        checked={props.vstsEntitlements === 3}
                                        disabled={props.currentUser.entitleId == UserRole.ToolsAdmin_Entitlement}

                                    />
                                    <MCSToolTip
                                        message="Entitles the user access to VSTS. VSTS recognizes this Role and Entitlement tiers and provides the user the necessary functions. VSTS L1 Support Admin: View client test cases. VSTS L2 GCT Admin: View, review, and approve client test cases and projects. VSTS L3 Dev Admin: Create and edit test cases."
                                        iconName="info"
                                    />
                                </div>
                            </RadioGroup>
                        </Col>
                    </Row>
                </>
            }
        </>
    );
}

export default AdditionalEntitlements